import { PublicClientApplication } from "@azure/msal-browser";

// msalConfig.js
export const msalConfig = {
  auth: {
    clientId: "79f96301-5983-43fb-ba89-22701ec51f63", // Obtén este valor desde Azure AD
    authority: "https://login.microsoftonline.com/common", // URL de tu directorio
    redirectUri: "https://balanzas.tasa.com.pe/auth", // URI donde se redirigirá tras iniciar sesión
  },
  cache: {
    cacheLocation: "localStorage", // Puede ser "sessionStorage" o "localStorage"
    storeAuthStateInCookie: true, // Recomendado para navegadores antiguos
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const msalInstance = new PublicClientApplication(msalConfig);